<template>
  <div>
    <CCard style="height: 155px">
      <Summation ref="summationView" @click="onClick" />
    </CCard>

    <CCard>
      <Device ref="deviceView" @change="onChangedSite" prefix="sslm_"/>
    </CCard>

    <Event ref="eventView" @update="updateSummation" @click="onClickEvent" />

    <EventDialog ref="eventDialog" @click="onClickEvent"/>
  </div>
</template>

<script>
import Dashboard from "@/views/dashboard/Dashboard.vue";
import Summation from "@/views/sslm/Summation";

export default {
  name: "SSLMBoard",
  extends: Dashboard,
  components: {
      Summation
  },
  methods: {
    onClick(item) {
      // console.log('Dashboard::onClick Summation click item:', JSON.stringify(item,null,2))
      if (item.val != 0 && item.key != "DN") {
        var eventTable = this.$refs.eventView.getTable();
        this.$refs.eventDialog.show(item, eventTable.data);
      }
    },
    updateSummation(data) {
      var where = {
        and: [
          {
            status: 0,
            service_type: "sslm",
          },
        ],
      };
      if (this.is_admin === false) {
        where.and.push({
          site_guid: {
            inq: this.user.site_guids,
          },
        });
      }
      this.$store
        .dispatch("rest/count", { model: "devices", where: where })
        .then((res) => {
          this.$refs.summationView.update(res.count, data);
        })
        .then(() => {
          var eventTable = this.$refs.eventView.getTable();
          eventTable.data.forEach((event) => {
            this.$refs.deviceView.setMarkerImage(event);
          });
        });
    },
  },    
};
</script>